module.exports = __webpack_public_path__ + "static/about-1de51d149aeb246e9c52ba4b045602d6.jpg";